import React, { Component } from 'react';
import { Modal, message, DatePicker, Input } from 'antd';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class PatientStatus extends Component {
    state = {
        params: {},
        visible: false,
        confirmLoading: false,
    }

    show = () => {
        const patientStatus = sessionStorage.getItem('patientStatus');
        const params = patientStatus ? JSON.parse(patientStatus) : {};
        this.setState({
            params,
            visible: true,
        });
    }

    handleOk = () => {
        const { params, params: { quitTime, quitComment } } = this.state;
        if (!quitTime) {
            message.warning('请选择退出时间');
            return;
        }
        if (!quitComment || (quitComment && quitComment.trim() == '')) {
            message.warning('请输入退出原因');
            return;
        }
        const patientStatus = { ...params };
        sessionStorage.setItem('patientStatus', JSON.stringify(patientStatus));
        this.setState({ visible: false });
    }

    disabledDate = (current) => {
        const { maxDate } = this.props;
        const value = moment(moment(maxDate).format(dateFormat)).add(1, 'd').valueOf();
        return current && current.valueOf() >= value;
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    handleSelectChange = (value, field) => {
        const { params } = this.state;
        params[field] = value;
        this.setState({ params });
    }

    handleInputChange = (e, field) => {
        const { params } = this.state;
        params[field] = e.target.value;
        this.setState({ params });
    }

    handleDateChange = (date, dateString) => {
        const { params } = this.state;
        params.quitTime = dateString;
        this.setState({ params });
    }

    render () {
        const { value } = this.props;
        const { visible, params: { quitTime, quitComment = '' }, confirmLoading } = this.state;
        const newQuitTime = quitTime ? moment(quitTime) : null;
        let title = '';
        let content = null;
        if (value == '退出') {
            title  = '退出记录';
            content = (
                <ul className="modal-list">
                    <li className="modal-item">
                        <div className="item-left" style={{width: '25%'}}>
                            退出时间:
                        </div>
                        <div className="item-right">
                            <DatePicker
                                placeholder="请选择"
                                style={{width: 120}}
                                value={newQuitTime}
                                format={dateFormat}
                                disabledDate={this.disabledDate}
                                onChange={this.handleDateChange}
                            />
                        </div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left" style={{width: '25%'}}>
                            退出原因:
                        </div>
                        <div className="item-right">
                            <Input
                                style={{width: 240}}
                                placeholder='请输入'
                                value={quitComment}
                                onChange={e => this.handleInputChange(e, 'quitComment')}
                            />
                        </div>
                    </li>
                </ul>
            );
        }
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content">
                    {content}
                </div>
            </Modal>
        )
    }
}

export default PatientStatus;


// WEBPACK FOOTER //
// ./src/components/execute/PatientStatus.js